import { Link } from "react-router-dom";

const StateButton = (props) => {    
    let userData = JSON.parse(localStorage.getItem("virtualOfficeLoginInfo"));
    let to = props.to;
    if(userData !== undefined && userData !== null){
        to = props.userTo;
    }

    return (
        <Link className={props.className} to={to}>{props.text}</Link>
    );
};

export default StateButton;